import React, { useEffect } from "react";
import { connect } from "react-redux";
import { getGradeList } from "../../actions/Grade.action";
import ViewRangedWeeklyFiles from "../../components/ViewRangedWeeklyFiles/ViewRangedWeeklyFiles";
import PublicLayout from "../../components/shared/PublicLayout/PublicLayout";

const PublicViewRangedWeeklyFilePage = ({ grades, getGradeList }) => {
  useEffect(() => {
    getGradeList();
  }, []);
  return (
    <div className="bg_light">
      <PublicLayout title={`Weekly Assessment (Ranged)`}>
        <ViewRangedWeeklyFiles grades={grades} hideDelete />
      </PublicLayout>
    </div>
  );
};

const mapStateToProps = (state) => ({
  grades: state.grade.grade,
});

export default connect(mapStateToProps, { getGradeList })(
  PublicViewRangedWeeklyFilePage
);
